











































import Vue from 'vue'
import Signature from '@/components/Services/Remittances/Signature/Signature.vue'

export default Vue.extend({
  name: 'app',
  components: {
    appSignature: Signature,
  },
  data() {
    return {
      drawProps: {
        title: 'sign',
        colors: [
          '#EeEAEA',
          '#292929',
          '#00A0FF',
          '#FF29AA',
          '#FFE500',
          '#FF3030',
          '#12EB0A',
        ],
        bgColors: [
          '#EAEAEA',
          '#292929',
          '#00A0FF',
          '#FF29AA',
          '#FFE500',
          '#FF3030',
          '#12EB0A',
        ],
        lineColor: '#292929',
        bgColor: '#EAEAEA',
      },
      error: false,
      sent: false,
    }
  },

  methods: {
    changeLineColor(color: string): void {
      this.drawProps.lineColor = color
    },

    changeBgColor(color: string): void {
      this.drawProps.bgColor = color
    },
    saveDrawing(): void {},
    onSent(error: boolean): void {
      this.error = error
      this.sent = true
    },
  },
})
